import { useTranslation } from '@tecma/i18n';
import { useSelector } from 'react-redux';

import { applicationStateSelectors } from 'store/slices/applicationState/selectors';
import { redirectToConfigurator } from 'utils/redirectToConfigurator';

export const useFooterSection = (showContactUsModal: () => void, forceContactUsDisplay?: boolean) => {
  const { t } = useTranslation();
  const assetType = useSelector(applicationStateSelectors.selectAssetTypology);
  const coliving = useSelector(applicationStateSelectors.selectColiving);
  const spaceConfigurator = useSelector(applicationStateSelectors.selectSpaceConfigurator);

  const showContactButton = forceContactUsDisplay || !assetType || (assetType === 'room' && !coliving?.enabled) || (assetType === 'apartment' && !spaceConfigurator?.enabled);
  const sectionContent = showContactButton ? t('footer-section.content.contact-us') : t('footer-section.content.create-configuration');
  const sectionButtonLabel = showContactButton
    ? t('footer-section.button-label.contact-us')
    : t('footer-section.button-label.create-configuration');

  const onClick = () => {
    if (showContactButton) {
      showContactUsModal();
    } else {
      redirectToConfigurator({ assetType, spaceConfigurator, coliving });
    }
  };

  return {
    showContactButton,
    sectionContent,
    sectionButtonLabel,
    onClick,
  };
};
